/**
 * @file Series/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const ORIENTATION_VERTICAL = "vertical";
export const WATCH_MEDIUMS = [
    "original series",
    "tv",
    "web series",
    "digital series",
];
